import { FC } from 'react';
import { PageWrapper } from 'ui/components/PageWrapper';
import { GameSlider } from '../components/GameSlider';

export const DevPage: FC = () => {
  return (
    <PageWrapper>
      <div className="relative h-full w-full flex flex-col items-center justify-center">
        <GameSlider />
      </div>
    </PageWrapper>
  );
};
